// Maps a backend error `code` to panel-owned ES copy for «Cambiar titular». Same shape as its six
// siblings: specific causes get their own sentence, and only the unknown/absent case falls open to
// a generic. We never render the envelope's `message`/`detail` (untrusted backend string), nor the
// code itself.
//
// The spellings are the DELIVERED ones, `delivery_` prefix included — app-service's convention for
// its `deliveries` exceptions, and not the bare nouns this feature first proposed. `not_eligible`
// deliberately names no cause: backend groups blocked, anonymized and preregistered-shell accounts
// under that one code, so a sentence naming one of them would be a guess. The dialog tells those
// three apart BEFORE the write, where the account's own `active` and `status` are in hand.
//
// Two of these are reachable in normal use and four are a safety net. `delivery_recipient_conflict`
// is the one that earns its words: it means another agent moved the titular between this agent
// reading the card and confirming, and its sentence has to say so — refetching and repainting
// without explaining would look like the panel undid the agent's own work.
// TODO: i18n — copy en ES hasta Fase 1.
const SPECIFIC: Record<string, string> = {
  delivery_recipient_conflict: 'Otro agente ha cambiado el titular mientras lo hacías.',
  // Verbatim from its siblings: one fact, one sentence, wherever the agent meets it.
  delivery_state_conflict: 'La entrega ha cambiado de estado.',
  delivery_recipient_is_current: 'Esa cuenta ya es la titular de esta entrega.',
  delivery_recipient_not_found: 'Esa cuenta ya no existe.',
  delivery_recipient_not_eligible: 'Esa cuenta no puede ser titular de una entrega.',
};

export function changeRecipientError(code: string | null): string {
  // Own-property only: the code is wire data, and a bare lookup also resolves inherited names, so a
  // `constructor` code would come back truthy and carry no readable message.
  const key = code?.toLowerCase() ?? '';
  const message = Object.hasOwn(SPECIFIC, key) ? SPECIFIC[key] : undefined;
  return message ?? 'No se pudo cambiar el titular. Inténtalo de nuevo.'; // TODO: i18n
}
